import * as React from 'react'
import { ComponentExt } from 'util/reactExt'
import { inject, observer } from 'mobx-react'
import { withRouter, RouteComponentProps, Link } from 'react-router-dom'
import Cate from 'components/layout/CateLayout'
import Card from 'components/Card'
import Breadcrumb from 'components/Breadcrumb'
import styles from './index.scss'

export interface SearchResultState {
  searchKey: string
}
export interface SearchResultProps extends RouteComponentProps<any> {
  globalStore?: IGlobalStore.GlobalStore
  searchStore?: ISearchStore.SearchStore
}

@inject('globalStore', 'searchStore')
@observer
class SearchResult extends ComponentExt<SearchResultProps, any> {
  componentDidMount() {
    const q = new URLSearchParams(this.props.location.search).get('q')
    this.props.searchStore.setSearchKeyWords(q)
    this.props.searchStore.querySearchResult(1, 5)
  }

  toDetail = (id, type, content?) => {
    if (type === '1000104') {
      return window.open(`#/topicdetail/${id}`, '_blank')
    }
    if (type === '1000105') {
      return window.open(content, '_blank')
    }
    window.open(`#/course/${id}?type=${type}`)
  }

  render() {
    const { searchKeyWords, searchResult } = this.props.searchStore
    return (
      <div className={styles.searchResult}>
        <div className={styles.searchResultInner}>
          <div className={styles.safe}>
            <Breadcrumb
              data={[
                { name: '学院首页', url: '/' },
                { name: '搜索结果', url: '' },
              ]}
            />
          </div>
          {searchResult.course.total > 0 && (
            <div className={styles.resultSection}>
              <h3 className={styles.sectionHeader}>
                <div className={styles.sectionTitle}>
                  共有<span>{searchResult.course.total}</span>门包含“
                  <span>{searchKeyWords || '汪总'}</span>”的视频
                </div>
                {searchResult.course.total > 5 && (
                  <a
                    style={{
                      fontSize: '16px',
                      color: '#333',
                      lineHeight: '16px',
                    }}
                    href={`#/searchresult/detail/course?q=${searchKeyWords}&t=course`}
                    target="_blank"
                  >
                    查看全部
                  </a>
                )}
              </h3>
              <Cate title="" noheader>
                {searchResult.course.data.slice(0, 5).map(course => {
                  const {
                    id,
                    type,
                    title,
                    img_url,
                    view_count,
                    course_time,
                    content,
                  } = course
                  return (
                    <React.Fragment key={id}>
                      <Card
                        title={title}
                        dataType={type}
                        cover={img_url}
                        time={course_time}
                        onClick={() => this.toDetail(id, type, content)}
                        watch={view_count}
                      />
                    </React.Fragment>
                  )
                })}
              </Cate>
            </div>
          )}

          {searchResult.topic.total > 0 && (
            <div className={styles.resultSection}>
              <h3 className={styles.sectionHeader}>
                <div className={styles.sectionTitle}>
                  共有<span>{searchResult.topic.total}</span>门包含“
                  <span>{searchKeyWords}</span>”的专题
                </div>
                {searchResult.topic.total > 5 && (
                  <a
                    style={{
                      fontSize: '16px',
                      color: '#333',
                      lineHeight: '16px',
                    }}
                    href={`#/searchresult/detail/course?q=${searchKeyWords}&t=topic`}
                    target="_blank"
                  >
                    查看全部
                  </a>
                )}
              </h3>
              <Cate title="" noheader type={4}>
                {searchResult.topic.data.slice(0, 4).map(topic => {
                  const { id, type, title, img_url, view_count } = topic
                  return (
                    <React.Fragment key={id}>
                      <Card
                        title={title}
                        dataType={type}
                        type="middle"
                        cover={img_url}
                        onClick={() => this.toDetail(id, type, true)}
                        watch={view_count}
                      />
                    </React.Fragment>
                  )
                })}
              </Cate>
            </div>
          )}

          {searchResult.article.total > 0 && (
            <div className={styles.resultSection}>
              <h3 className={styles.sectionHeader}>
                <div className={styles.sectionTitle}>
                  共有<span>{searchResult.article.total}</span>门包含“
                  <span>{searchKeyWords}</span>”的文章
                </div>
                {searchResult.article.total > 5 && (
                  <a
                    style={{
                      fontSize: '16px',
                      color: '#333',
                      lineHeight: '16px',
                    }}
                    href={`#/searchresult/detail/course?q=${searchKeyWords}&t=article`}
                    target="_blank"
                  >
                    查看全部
                  </a>
                )}
              </h3>
              <Cate title="" noheader>
                {searchResult.article.data.slice(0, 5).map(article => {
                  const {
                    id,
                    type,
                    title,
                    img_url,
                    view_count,
                    course_time,
                  } = article
                  return (
                    <React.Fragment key={article.id}>
                      <Card
                        title={title}
                        dataType={type}
                        cover={img_url}
                        time={course_time}
                        onClick={() => this.toDetail(id, type)}
                        watch={view_count}
                      />
                    </React.Fragment>
                  )
                })}
              </Cate>
            </div>
          )}

          {/* {searchResult.courseware.total > 0 && (
            <div className={styles.resultSection}>
              <h3 className={styles.sectionHeader}>
                <div className={styles.sectionTitle}>
                  共有<span>{searchResult.courseware.total}</span>门包含“<span>
                    {searchKeyWords}
                  </span>”的课件
                </div>
                {searchResult.courseware.total > 5 && (
                  <a
                    style={{
                      fontSize: '16px',
                      color: '#333',
                      lineHeight: '16px',
                    }}
                    href={`#/searchresult/detail/course?q=${searchKeyWords}&t=article`}
                    target="_blank"
                  >
                    查看全部
                  </a>
                )}
              </h3>
              <Cate title="" noheader>
                {searchResult.courseware.data.slice(0, 5).map(article => {
                  const {
                    id,
                    type,
                    title,
                    img_url,
                    view_count,
                    course_time,
                  } = article
                  return (
                    <React.Fragment key={article.id}>
                      <Card
                        title={title}
                        dataType={type}
                        cover={img_url}
                        time={course_time}
                        onClick={() => this.toDetail(id, type)}
                        watch={view_count}
                      />
                    </React.Fragment>
                  )
                })}
              </Cate>
            </div>
          )} */}
        </div>
      </div>
    )
  }
}

export default withRouter(SearchResult)
